import { FC, useState } from 'react'
import Lightbox from 'react-image-lightbox';

interface IProps {
    images: string[];
}

export const ProfileImages: FC<IProps> = ({ images }) => {
    const [isGallery, setisGallery] = useState<boolean>(false);
    const [photoIndex, setphotoIndex] = useState<any>(0);
    
  return (
    <>
        <div className='col-sm-12'>
            <div className='row mb-3'>
                {
                    images?.length > 0 && images.map((path, index) => (
                        path ?
                        <div className='col-sm-4 mb-2' key={index}>
                            <div className='row'>
                                <div className='col-sm-12 d-flex justify-content-center align-items-center' style={{cursor: 'pointer'}}>
                                    <img 
                                        onClick={() => {
                                                setisGallery(true);
                                                setphotoIndex(index);
                                            }}
                                        src={path} 
                                        alt="" 
                                        className='rounded-3 object-fit-cover'
                                        style={{cursor: 'pointer', backgroundColor: '#f5f5f5'}}                                            
                                        width={120}
                                        height={120} 
                                    />
                                </div>
                            </div>
                        </div> : null
                    ))
                }
            </div>
        </div>

        {isGallery ? (
            <Lightbox
                mainSrc={images[photoIndex]}
                nextSrc={images[(photoIndex + 1) % images.length]}
                prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                enableZoom={true}
                onCloseRequest={() => {
                    setisGallery(false);
                }}
                onMovePrevRequest={() => {
                    setphotoIndex((photoIndex + images.length - 1) % images.length);
                }}
                onMoveNextRequest={() => {
                    setphotoIndex((photoIndex + 1) % images.length);
                }}
                imageCaption={"Image " + parseFloat(photoIndex + 1)}
            />
        ) : null}
  </>
)}